/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  Attestation,
  GetChallengeChallengeId200Response,
  GetChallengeChallengeIdV2200Response,
  GetMe200Response,
  GetMeOrgs200Response,
  GetTokenV2200Response,
  IDRequest,
  IDRequestV2,
  PostAttestationV3200Response,
  PostDirectId201Response,
  PostId200Response,
  PostSsoResolveRequest,
  PostTokenRequestV2,
  RecoverRequest,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    AttestationFromJSON,
    AttestationToJSON,
    GetChallengeChallengeId200ResponseFromJSON,
    GetChallengeChallengeId200ResponseToJSON,
    GetChallengeChallengeIdV2200ResponseFromJSON,
    GetChallengeChallengeIdV2200ResponseToJSON,
    GetMe200ResponseFromJSON,
    GetMe200ResponseToJSON,
    GetMeOrgs200ResponseFromJSON,
    GetMeOrgs200ResponseToJSON,
    GetTokenV2200ResponseFromJSON,
    GetTokenV2200ResponseToJSON,
    IDRequestFromJSON,
    IDRequestToJSON,
    IDRequestV2FromJSON,
    IDRequestV2ToJSON,
    PostAttestationV3200ResponseFromJSON,
    PostAttestationV3200ResponseToJSON,
    PostDirectId201ResponseFromJSON,
    PostDirectId201ResponseToJSON,
    PostId200ResponseFromJSON,
    PostId200ResponseToJSON,
    PostSsoResolveRequestFromJSON,
    PostSsoResolveRequestToJSON,
    PostTokenRequestV2FromJSON,
    PostTokenRequestV2ToJSON,
    RecoverRequestFromJSON,
    RecoverRequestToJSON,
} from '../models';

export interface GetChallengeChallengeIdRequest {
    challengeId: string;
    slashIDSdkVersion?: string;
}

export interface GetChallengeChallengeIdV2Request {
    challengeId: string;
    slashIDSdkVersion?: string;
}

export interface GetChallengePackChallengePackIdRequest {
    challengePackId: string;
    slashIDSdkVersion?: string;
}

export interface GetTokenRequest {
    slashIDOrgID: string;
    slashIDSdkVersion?: string;
}

export interface GetTokenV2Request {
    slashIDOrgID: string;
    slashIDSdkVersion?: string;
}

export interface PostAttestationRequest {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostAttestationV2Request {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostAttestationV3Request {
    attestation: Attestation;
    slashIDSdkVersion?: string;
}

export interface PostDirectIdRequest {
    slashIDSdkVersion?: string;
}

export interface PostIdRequest {
    slashIDOrgID: string;
    iDRequest: IDRequest;
    slashIDSdkVersion?: string;
}

export interface PostIdV2Request {
    slashIDOrgID: string;
    iDRequestV2: IDRequestV2;
    slashIDSdkVersion?: string;
}

export interface PostRecoverRequest {
    slashIDOrgID: string;
    recoverRequest: RecoverRequest;
    slashIDSdkVersion?: string;
}

export interface PostSsoResolveOperationRequest {
    slashIDOrgID: string;
    postSsoResolveRequest?: PostSsoResolveRequest;
}

export interface PostTokenV2Request {
    slashIDOrgID: string;
    postTokenRequestV2: PostTokenRequestV2;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async getChallengeChallengeIdRaw(requestParameters: GetChallengeChallengeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeId200Response>> {
        if (requestParameters.challengeId === null || requestParameters.challengeId === undefined) {
            throw new runtime.RequiredError('challengeId','Required parameter requestParameters.challengeId was null or undefined when calling getChallengeChallengeId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/challenge/{challenge_id}`.replace(`{${"challenge_id"}}`, encodeURIComponent(String(requestParameters.challengeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengeChallengeId(requestParameters: GetChallengeChallengeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeId200Response> {
        const response = await this.getChallengeChallengeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getChallengeChallengeIdV2Raw(requestParameters: GetChallengeChallengeIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        if (requestParameters.challengeId === null || requestParameters.challengeId === undefined) {
            throw new runtime.RequiredError('challengeId','Required parameter requestParameters.challengeId was null or undefined when calling getChallengeChallengeIdV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/challenge/{challenge_id}/v2`.replace(`{${"challenge_id"}}`, encodeURIComponent(String(requestParameters.challengeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengeChallengeIdV2(requestParameters: GetChallengeChallengeIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response> {
        const response = await this.getChallengeChallengeIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getChallengePackChallengePackIdRaw(requestParameters: GetChallengePackChallengePackIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        if (requestParameters.challengePackId === null || requestParameters.challengePackId === undefined) {
            throw new runtime.RequiredError('challengePackId','Required parameter requestParameters.challengePackId was null or undefined when calling getChallengePackChallengePackId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/challenge_pack/{challenge_pack_id}`.replace(`{${"challenge_pack_id"}}`, encodeURIComponent(String(requestParameters.challengePackId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getChallengePackChallengePackId(requestParameters: GetChallengePackChallengePackIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.getChallengePackChallengePackIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */
    async getMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMe200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMe200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve details of the person and all the organizations they belong to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person details and list of organizations
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMe200Response> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */
    async getMeOrgsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMeOrgs200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/me/orgs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMeOrgs200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all the organizations the person belongs to, including:  - The organization of the request: the person must be a member of the organization you authenticate    with for you to be allowed to retrieve this list  - Any other organizations that share the person pool with the organization specified in the request and to which the person also belongs.    A hierarchy of organizations can be created using [this API endpoint](/docs/api/post-organizations-suborganizations).    When organizations are configured to share a person pool, if the same person registers with multiple organizations    in the pool using the same handle, all organizations will see the same person ID for that person. 
     * Retrieve the person list of organizations
     */
    async getMeOrgs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMeOrgs200Response> {
        const response = await this.getMeOrgsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenRaw(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization, return a new token for the same user in the Organization specified in the SlashID-OrgID request header. For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getToken(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response> {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenV2Raw(requestParameters: GetTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTokenV2200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling getTokenV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token/v2`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTokenV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async getTokenV2(requestParameters: GetTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTokenV2200Response> {
        const response = await this.getTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postAttestationRaw(requestParameters: PostAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeId200Response>> {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) {
            throw new runtime.RequiredError('attestation','Required parameter requestParameters.attestation was null or undefined when calling postAttestation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attestation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters.attestation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestation(requestParameters: PostAttestationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeId200Response> {
        const response = await this.postAttestationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postAttestationV2Raw(requestParameters: PostAttestationV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeChallengeIdV2200Response>> {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) {
            throw new runtime.RequiredError('attestation','Required parameter requestParameters.attestation was null or undefined when calling postAttestationV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attestation/v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters.attestation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeChallengeIdV2200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestationV2(requestParameters: PostAttestationV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeChallengeIdV2200Response> {
        const response = await this.postAttestationV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postAttestationV3Raw(requestParameters: PostAttestationV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostAttestationV3200Response>> {
        if (requestParameters.attestation === null || requestParameters.attestation === undefined) {
            throw new runtime.RequiredError('attestation','Required parameter requestParameters.attestation was null or undefined when calling postAttestationV3.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attestation/v3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttestationToJSON(requestParameters.attestation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostAttestationV3200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postAttestationV3(requestParameters: PostAttestationV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostAttestationV3200Response> {
        const response = await this.postAttestationV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postDirectIdRaw(requestParameters: PostDirectIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostDirectId201Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/direct-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostDirectId201ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postDirectId(requestParameters: PostDirectIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostDirectId201Response> {
        const response = await this.postDirectIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postIdRaw(requestParameters: PostIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postId.');
        }

        if (requestParameters.iDRequest === null || requestParameters.iDRequest === undefined) {
            throw new runtime.RequiredError('iDRequest','Required parameter requestParameters.iDRequest was null or undefined when calling postId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDRequestToJSON(requestParameters.iDRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postId(requestParameters: PostIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postIdV2Raw(requestParameters: PostIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postIdV2.');
        }

        if (requestParameters.iDRequestV2 === null || requestParameters.iDRequestV2 === undefined) {
            throw new runtime.RequiredError('iDRequestV2','Required parameter requestParameters.iDRequestV2 was null or undefined when calling postIdV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/id/v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IDRequestV2ToJSON(requestParameters.iDRequestV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postIdV2(requestParameters: PostIdV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postRecoverRaw(requestParameters: PostRecoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostId200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postRecover.');
        }

        if (requestParameters.recoverRequest === null || requestParameters.recoverRequest === undefined) {
            throw new runtime.RequiredError('recoverRequest','Required parameter requestParameters.recoverRequest was null or undefined when calling postRecover.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/recover`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecoverRequestToJSON(requestParameters.recoverRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostId200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async postRecover(requestParameters: PostRecoverRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostId200Response> {
        const response = await this.postRecoverRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */
    async postSsoResolveRaw(requestParameters: PostSsoResolveOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postSsoResolve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sso/resolve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostSsoResolveRequestToJSON(requestParameters.postSsoResolveRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resolve endpoint for SSO flows using PKCE.
     * SSO resolve challenge endpoint
     */
    async postSsoResolve(requestParameters: PostSsoResolveOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSsoResolveRaw(requestParameters, initOverrides);
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async postTokenV2Raw(requestParameters: PostTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTokenV2200Response>> {
        if (requestParameters.slashIDOrgID === null || requestParameters.slashIDOrgID === undefined) {
            throw new runtime.RequiredError('slashIDOrgID','Required parameter requestParameters.slashIDOrgID was null or undefined when calling postTokenV2.');
        }

        if (requestParameters.postTokenRequestV2 === null || requestParameters.postTokenRequestV2 === undefined) {
            throw new runtime.RequiredError('postTokenRequestV2','Required parameter requestParameters.postTokenRequestV2 was null or undefined when calling postTokenV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (requestParameters.slashIDOrgID !== undefined && requestParameters.slashIDOrgID !== null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters.slashIDOrgID);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token/v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostTokenRequestV2ToJSON(requestParameters.postTokenRequestV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTokenV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Given a token for a Person in an Organization: return a new token for the same user in the Organization specified in the SlashID-OrgID request header OR return a list of challenges that need to be resolved in order to obtain the token.  For the call to succeed the following conditions must be met: - the token must be valid at the time of the request - the two Organizations must share the same person pool - the user must be a member of both Organizations This operation does not count as an authentication, so the new token will have the same expiration time as the original. 
     * Get a new token for the specified Organization ID
     */
    async postTokenV2(requestParameters: PostTokenV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTokenV2200Response> {
        const response = await this.postTokenV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
